import { render, staticRenderFns } from "./robert-mondovi-vineyards.vue?vue&type=template&id=20ddb089&scoped=true"
import script from "./robert-mondovi-vineyards.vue?vue&type=script&lang=js"
export * from "./robert-mondovi-vineyards.vue?vue&type=script&lang=js"
import style0 from "./robert-mondovi-vineyards.vue?vue&type=style&index=0&id=20ddb089&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ddb089",
  null
  
)

export default component.exports